<template>
    <div class="p-2" style="width:250px">
       <vs-row>
          <vs-col class="mb-3" vs-w="12">
            <form-label>{{$t('GradeControl.Location.Type')}}</form-label>
            <v-select
              label="name"
              :options="locationTypes"
              :reduce="type => type.id"
              v-model="locationType"
              @input="setType"
              class="w-full"
              name="locationType"
            />
          </vs-col>
       </vs-row>
       <vs-row>
          <vs-col class="mb-3" vs-w="12">
            <form-label>{{$t('GradeControl.Location.Name')}}</form-label>
            <v-select
              label="code"
              :options="locations"
              :reduce="location => location.locationId"
              v-model="locationId"
              @input="setSelected"
              class="w-full"
              name="locationId"
            />
          </vs-col>
       </vs-row>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import LocationTypeEnum from "../../LocationTypeEnum.js";
import { FormLabel } from "./../../../../shared/components";

export default {
  name: 'LocationIdCellEditor',
  data() {
    return {
      locationId: null,
      locationType: LocationTypeEnum.Production,
      locationTypes: LocationTypeEnum.definition
    }
  },
  computed: {
    locations() {
      return this.params.context.componentParent.locations.filter(l => l.type === this.locationType);
    }
  },
  components: {
    'v-select': vSelect,
    FormLabel
  },
  created() {
    this.locationType = this.params.value.locationType;
    this.locationId = this.params.value.locationId;
  },
  methods: {
    getValue() {
      return this.locationId
    },
    isPopup() {
      return true;
    },
    setType(type) {
      this.locationType = type;
      this.locationId = null;
    },
    setSelected(id) {
      this.locationId = id;
      this.params.api.stopEditing();
    }
  }
}
</script>
